import axios from 'axios';

const validateQuantity = (delayed, intent, inStock, commited, qtyReserved) => {
  let valid = true;
  if (delayed == false && intent == false) {
    if((inStock - commited) < qtyReserved){
      valid = false;
    }
  } else if (delayed == true){
    // TODO
  } else if (intent == true) {
    // Aucune validation. On laisse passer.
  }

  return valid;

}

export default {
  isQuantityValid(reservation){
    let valid = true;
    if (reservation == null) return true;
    if (reservation.intent === true) return true;
    if(reservation.product && reservation.product.quantities && reservation.product.quantities[0]){
      valid = validateQuantity(reservation.delayed, reservation.intent, reservation.product.quantities[0].on_hand, reservation.product.quantities[0].in_command, reservation.product.quantities[0].reserved)
    }else{
      valid = false;
    }
    return valid;
  },
  isQuantityValidV2(reservation){
    let valid = true;
    if (reservation == null) return valid;
    if (reservation.intent === true) return valid;
    if (reservation.completed === true) return valid;
    if(reservation.product && reservation.product.quantity != null){
      valid = validateQuantity(reservation.delayed, reservation.intent, reservation.product.quantity.onHand, reservation.product.quantity.confirmed, reservation.product.quantity.reserved)
    }else{
      valid = false;
    }
    return valid;
  },
}
